import ConfirmacaoConvitePage from "views/Pages/ConfirmacaoConvitePage.jsx";
import ConfirmacaoEmailPage from "views/Pages/ConfirmacaoEmailPage.jsx";
import Dashboard from "layouts/Dashboard.jsx";
import DashboardAreaAberta from "layouts/DashboardAreaAberta.jsx";
import LandingPage from "views/LandingPage/LandingPage.jsx";
import LoginPage from "views/Pages/LoginPage.jsx";
import PlanosPage from "views/Pages/PlanosPage.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import ResetPasswordPage from "views/Pages/ResetPasswordPage.jsx";

var indexRoutes = [
  { path: "/dashboard", name: "Home", component: Dashboard },
  { path: "/login", name: "Login", component: LoginPage },
  { path: "/cadastro", name: "Cadastro", component: RegisterPage },
  { path: "/resetar-senha", name: "Resetar Senha", component: ResetPasswordPage },
  { path: "/confirmacao-email", name: "Resetar Senha", component: ConfirmacaoEmailPage },
  { path: "/confirmacao-convite", name: "Confirmar Convite", component: ConfirmacaoConvitePage },
  { path: "/planos", name: "Planos", component: PlanosPage },
  { path: "/area-aberta", name: "Simuladores", component: DashboardAreaAberta },
  { path: "/", name: "Landing Page", component: LandingPage },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx